import angular from 'angular';

export default angular.module('curalate.analytics-at-a-glance', [
  'curalate',
  'curalate.default',
  'highcharts-ng',
  'ngAnimate',
  'unison',
]);
